<div class="modal-content">
    <div class="modal-header border-0">
        <h3 class="modal-title" id="modulesModalLabel">Nueva categoría</h3>
        <button type="button" class="btn-close" (click)="modal.dismissAll()"></button>
    </div>
    <div class="modal-body p-4">
        <form novalidate [formGroup]="categoryVehicleForm">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="mb-3">
                        <label class="col-12 form-label m-0" for="cv_description">Descripción</label>
                        <div class="col-12 custom-input">
                            <input class="form-control" id="cv_description" type="text" formControlName="description"
                                   [ngClass]="{ 'is-invalid' : (descriptionValidate?.touched || validate) && descriptionValidate?.errors, 'is-valid' : !descriptionValidate?.errors}">
                        </div>
                        @if (descriptionValidate?.errors) {
                            <div class="invalid-feedback">Ingrese una descripción válida.</div>
                        }
                    </div>

                    <div class="mb-3">
                        <label class="col-12 form-label m-0" for="cv_comfort">Comodidad</label>
                        <div class="col-12 custom-input">
                            <tag-input
                                    formControlName="comfort"
                                    [class.is-invalid]="categoryVehicleForm.get('comfort')?.touched && categoryVehicleForm.get('comfort')?.invalid"
                                    [editable]="true"
                                    class="form-control">
                            </tag-input>


                            <textarea class="form-control" id="cv_comfort" formControlName="comfort" rows="2"></textarea>
                        </div>
                        <div class="valid-feedback"></div>
                    </div>
                    <div class="mb-3">
                        <label class="col-12 form-label m-0" for="cv_security">Seguridad</label>
                        <div class="col-12 custom-input">
                            <textarea class="form-control" id="cv_security" formControlName="security" rows="2"></textarea>
                        </div>
                        <div class="valid-feedback"></div>
                    </div>
                    <div class="mb-3">
                        <label class="col-12 form-label m-0" for="cv_vehicles_description">Vehículos</label>
                        <div class="col-12 custom-input">
                            <textarea class="form-control" id="cv_vehicles_description" formControlName="vehicles_description" rows="2"></textarea>
                        </div>
                        <div class="valid-feedback"></div>
                    </div>


                </div>
                <div class="col-12 col-md-6">
                    <div class="mb-3">
                        <label class="col-12 form-label m-0" for="cv_image_url">Imagen de la categoría</label>
                        <div class="col-12 custom-input">
                            <input class="form-control" id="cv_image_url" type="file" formControlName="image"/>
                        </div>
                    </div>

                    <!-- Previsualización de la imagen -->
                    <div *ngIf="imagenUrl" class="mt-3 text-center img-cat">
                        <img [src]="imagenUrl" alt="Selected image" style="border-radius:5px; width: 100%; max-width: 400px; height: auto; object-fit: cover;">
                    </div>
                </div>


            </div>
            <div formArrayName="capacityForm">
                <div class="row">
                    <h3>Capacidad de esta categoría</h3>
                    <div class="col-12 col-md-3" *ngFor="let capacity of capacityForm.controls; let i = index" [formGroupName]="i">
                        <label class="col-12 form-label m-0" for="cv_vehicles_description">{{categoryCapacity[i].value}}</label>
                        <input class="form-control" type="number" placeholder="Ej. 1" formControlName="quantity">
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer border-0 pt-3">
        <button type="button" class="btn btn-outline-secondary" (click)="modal.dismissAll()">Cerrar</button>
        <button type="button" class="btn btn-primary" (click)="add()">Agregar</button>
    </div>
</div>
